import React from "react";
import Iconify from "../../iconify";
import IconCode from "@/src/lib/iconCode";
import { NEXT_IMAGE_CDN } from "@/src/lib/util/config";
import CustomIconButton from "@/src/lib/ui/iconButton";
import Link from "next/link";

const fallbackLogo = `${NEXT_IMAGE_CDN}/icon/hod_logo.svg`;

const NotificationPopup = ({ props, onClose }) => {
    const { imageUrl, title, message, link } = props;
    const displayedImage = imageUrl || fallbackLogo;
    const isFallbackLogo = displayedImage === fallbackLogo;

    return (
        <div style={{ position: "fixed", bottom: 16, right: 16, width: 360, zIndex: 9999 }}>
            <div className="shadow-lg rounded-md overflow-hidden bg-white">
                {/* Top Row: icon + title (left), close button (right) */}
                <div className="flex items-center justify-between p-2" style={{ backgroundColor: "#f5f5f5" }}>
                    <div className="flex items-center gap-1">
                        <Iconify icon={IconCode.notification} />
                        <p className="font-bold">{title}</p>
                    </div>
                    <CustomIconButton onClick={onClose} size="small">
                        <Iconify icon={IconCode.close} />
                    </CustomIconButton>
                </div>

                {/* Second Row: 35% image, 65% text/link, fixed height */}
                <div className="flex flex-row" style={{ height: 100 }}>
                    {/* Left 35% - Image (fills entire area) */}
                    <div style={{ width: "40%", height: "100%", overflow: "hidden" }}>
                        <img
                            src={displayedImage}
                            alt="Notification"
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: isFallbackLogo ? "contain" : "cover",
                                objectPosition: "center",
                                transform: isFallbackLogo ? "scale(0.85)" : "none",
                                transformOrigin: "center",
                            }}
                        />
                    </div>

                    {/* Right 65% - Text + link */}
                    <div className="flex flex-col p-2" style={{ width: "60%" }}>
                        <p className="text-sm font-normal mb-1">{message}</p>
                        {link && (
                            <Link
                                href={link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-primary text-decoration-none"
                            >
                                View link
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotificationPopup;
